import _ from 'lodash';
import { type BoardSourceFieldValue, type PortalSettings } from '@gorilla/portal-shared/src/schemas';
import { BoardSourceSetupWizard } from '../BoardSourceSetupWizard';

type BoardSourceFieldProps = {
  value: BoardSourceFieldValue | undefined;
  portalSettings: PortalSettings;
  onChange: (value: BoardSourceFieldValue | undefined, portalSettings?: PortalSettings) => void;
};

export function BoardSourceField({ value, portalSettings, onChange }: BoardSourceFieldProps) {
  if (value) {
    return null;
  }

  return (
    <BoardSourceSetupWizard
      portalSettings={portalSettings}
      onDone={(newBoardSourceFieldValue, newBoardSource) => {
        if (newBoardSourceFieldValue) {
          if (!newBoardSource) {
            onChange(newBoardSourceFieldValue);
          } else {
            onChange(newBoardSourceFieldValue, { ...portalSettings, boardSources: [...portalSettings.boardSources, newBoardSource] });
          }
        }
      }}
    />
  );
}
